<era-pane>
  <h5 class="small-caps"
      i18n>Set Wallpaper</h5>
  <form [formGroup]="wallpaperForm"
        (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <label class="form-label"
             for="wallpaperUpload">Image</label>
      <input type="file"
             class="form-control"
             id="wallpaperUpload"
             (change)="onFileChange($event)"
             accept=".png,.jpg,.jpeg"
             required />
    </div>
    <div class="mb-3">
      <label class="form-label"
             for="where">Choose where to put the wallpaper</label>
      <select id="where"
              formControlName="where"
              required="true"
              class="form-select">
        <option value="1">Lock Screen Only</option>
        <option value="2">Home Screen Only</option>
        <option value="3">Both Home and Lock Screen</option>
      </select>
    </div>
    <button class="btn btn-primary"
            type="submit"
            [disabled]="!wallpaperForm.valid">Submit</button>
  </form>
</era-pane>